import React from 'react';
import classnames from 'classnames';
import { isMobile } from '../../../utils/ui.utils';
import classes from './swag-phone.scss';
const onPhoneClick = (e, isMobile) => {
  e.preventDefault();
  if (isMobile) {
    window.location.href = 'tel:718-878-4442';
  }
};
const SwagPhone = ({
  useBigPhone = false
}) => {
  const isMobileMode = isMobile();
  return /*#__PURE__*/React.createElement("div", {
    onClick: e => onPhoneClick(e, isMobileMode),
    className: classnames(classes.outerWrapper, {
      [classes.shortPhone]: isMobileMode
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.phoneWrapper)
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.icon, {
      [classes.bigIcon]: useBigPhone
    })
  }), /*#__PURE__*/React.createElement("p", {
    className: classnames(classes.number, {
      [classes.bigNumber]: useBigPhone
    })
  }, "718-878-4442")));
};
export default SwagPhone;